export const ICON_STYLES = {
  arrow: "expand-collapse",
  sign: "plus-minus",
  check: "check-x",
} as const;

export const ICON_POSITIONS = {
  left: "left",
  right: "right",
} as const;

const ICON_PATHS = {
  expand: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z",
  collapse: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z",
  plus: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z",
  minus: "M19 13H5v-2h14v2z",
  check: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z",
  close:
    "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
};

// the 24x24 icons BV draws (bronte-lib-components SVGIcon): no viewBox, no scaling
function renderSvg(path: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      width="24"
      aria-hidden="true"
      style={{ fill: "currentColor" }}
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d={path} />
    </svg>
  );
}

interface ShowHideIconProps {
  iconStyle?: string;
  iconPos?: string;
  isCollapsed: boolean;
}

export function ShowHideIcon({ iconStyle, iconPos, isCollapsed }: ShowHideIconProps) {
  let path = isCollapsed ? ICON_PATHS.expand : ICON_PATHS.collapse;
  if (iconStyle === ICON_STYLES.sign) {
    path = isCollapsed ? ICON_PATHS.plus : ICON_PATHS.minus;
  } else if (iconStyle === ICON_STYLES.check) {
    path = isCollapsed ? ICON_PATHS.check : ICON_PATHS.close;
  }

  // floated left or right of the label by the tab's styles, as in BV
  const iconPositionClass = iconPos === ICON_POSITIONS.right ? "icon-right" : "icon-left";
  return <span className={`show-hide-icon ${iconPositionClass}`}>{renderSvg(path)}</span>;
}
